import { endOfDay, isValid } from "date-fns";
import type { EventInput } from "@fullcalendar/core";
import type { BannerSwap } from "../../utils/@types";
import { toBannerSwapDate, isPermanentSwapEnd } from "./bannerDashboardUtils";
import { getBannerSwapStatusStyle } from "./bannerSwapStatusStyles";

export { isPermanentSwapEnd };

export function swapsToCalendarEvents(swaps: BannerSwap[]): EventInput[] {
  const events: EventInput[] = [];

  for (const swap of swaps) {
    const start = toBannerSwapDate(swap.startDate);
    let end = toBannerSwapDate(swap.endDate);

    if (!isValid(start) || !isValid(end)) {
      if (process.env.NODE_ENV === "development") {
        console.warn(
          `[bannerCalendar] Skipping swap with invalid dates: ${swap.swapUID}`
        );
      }
      continue;
    }

    const permanent = isPermanentSwapEnd(end);
    if (permanent) {
      // Permanent swaps have no real end date — show only on the day they went live.
      end = endOfDay(start);
    }

    if (end.getTime() < start.getTime()) {
      continue;
    }

    const style = getBannerSwapStatusStyle(swap.status);
    const channelCount = swap.channelIDs?.length ?? 0;
    const title = permanent
      ? `#${swap.swapUID} ${swap.swapName} (Permanent)`
      : `#${swap.swapUID} ${swap.swapName}`;

    events.push({
      id: swap.swapUID,
      title,
      start,
      end,
      extendedProps: {
        swap,
        status: swap.status,
        channelCount,
        permanent,
      },
      backgroundColor: style.backgroundColor,
      borderColor: style.borderColor,
      textColor: style.textColor,
    });
  }

  return events;
}
